var _path, _line, _path2, _path3, _line2, _line3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone-off",
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#fff",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10a7 7 0 0 0 10.846 5.85m2.002 -2a6.967 6.967 0 0 0 1.152 -3.85"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/MicOff.a31cfbd7efe44ddaa2258f1467dac257.svg";
export { ForwardRef as ReactComponent };